/* global Swiper */

const initSliders = () => {
  // Topbar slider
  new Swiper(".topbar__slider", {
    slidesPerView: 1,
    effect: "fade",
    loop: true,
    autoplay: { delay: 3000 },
    navigation: {
      nextEl: ".topbar__slider-next",
      prevEl: ".topbar__slider-prev",
    },
  });

  // Home Claims Slider
  new Swiper(".claims-swiper", {
    slidesPerView: "auto",
    spaceBetween: 120,
    loop: true,
    allowTouchMove: true,
    touchRatio: 1,
    touchAngle: 45,
    grabCursor: true,
    navigation: {
      nextEl: ".claims-swiper__next",
      prevEl: ".claims-swiper__prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 120,
      },
    },
  });

  // Product carousel slider
  new Swiper(".product-carousel-swiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    // Allow first click on Add to cart (Swiper blocks the first click by default)
    preventClicks: false,
    preventClicksPropagation: false,
    noSwipingSelector:
      ".product-card__cta, .ajax-add-to-cart, .add-to-cart, button, input",
    navigation: {
      nextEl: ".product-carousel__next",
      prevEl: ".product-carousel__prev",
    },
    scrollbar: {
      el: ".product-carousel .swiper-scrollbar",
      draggable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      990: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
    },
  });

  // block carousel
  const carousel_data = new Swiper(".carousel-data-swiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    effect: "fade",
  });

  const carousel_main = new Swiper(".carousel-swiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".carousel-widget__next",
      prevEl: ".carousel-widget__prev",
    },
    scrollbar: {
      el: ".carousel-widget .swiper-scrollbar",
      draggable: true,
    },
  });
  carousel_data.controller.control = carousel_main;
  carousel_main.controller.control = carousel_data;

  // Product Gallery
  if (document.querySelector(".product-gallery__main")) {
    const initialSlideIndex = 0;

    // Remove hidden variant slides from Swiper wrappers before init
    // (display:none slides break Swiper's spaceBetween position calculation)
    const pdpGallery = document.querySelector('.product-gallery');
    if (pdpGallery) {
      [['product-gallery__main', 'gallery-hidden-main'], ['product-gallery__thumbs', 'gallery-hidden-thumbs']].forEach(function (pair) {
        const swiperCls = pair[0], storageCls = pair[1];
        const wrapper = pdpGallery.querySelector('.' + swiperCls + ' .swiper-wrapper');
        if (!wrapper) return;
        let storage = pdpGallery.querySelector('.' + storageCls);
        if (!storage) {
          storage = document.createElement('div');
          storage.className = storageCls;
          storage.style.display = 'none';
          pdpGallery.appendChild(storage);
        }
        Array.from(wrapper.querySelectorAll('.swiper-slide')).forEach(function (slide) {
          if (slide.style.display === 'none') {
            slide.style.display = '';
            storage.appendChild(slide);
          }
        });
      });
    }

    // Initialize thumbnails first
    const galleryThumbs = new Swiper(".product-gallery__thumbs", {
      slidesPerView: 4,
      spaceBetween: 12,
      allowTouchMove: true,
      grabCursor: true,
      initialSlide: initialSlideIndex,
      breakpoints: {
        768: {
          slidesPerView: 6,
        },
        990: {
          slidesPerView: 6,
          spaceBetween: 16,
        },
      },
    });

    // Store reference globally
    window.productGalleryThumbs = galleryThumbs;

    // Initialize main gallery
    const productGalleryMain = new Swiper(".product-gallery__main", {
      slidesPerView: 1,
      effect: "slide",
      allowTouchMove: true,
      initialSlide: initialSlideIndex,
      spaceBetween: 20,
      navigation: {
        nextEl: ".product-gallery__next",
        prevEl: ".product-gallery__prev",
      },
      scrollbar: {
        el: ".product-gallery__main-wrapper .swiper-scrollbar",
        draggable: true,
      },
      // Remove thumbs controller to avoid conflicts with manual sync
      breakpoints: {
        768: {
          spaceBetween: 5,
        },
      },
    });

    // Store reference globally
    window.productGalleryMain = productGalleryMain;

    // Handle manual synchronization between main gallery and thumbnails
    productGalleryMain.on('slideChange', function () {
      // Use actual Swiper index to get the active slide directly
      const activeSlide = productGalleryMain.slides[productGalleryMain.activeIndex];

      if (activeSlide && galleryThumbs && activeSlide.style.display !== 'none') {
        const imageId = activeSlide.dataset.imageId;
        const imageType = activeSlide.dataset.imageType;
        const variantId = activeSlide.dataset.variantId;

        // Find matching thumbnail using actual Swiper index for slideTo
        const thumbSlides = galleryThumbs.slides;

        for (let i = 0; i < thumbSlides.length; i++) {
          const thumbSlide = thumbSlides[i];
          if (thumbSlide.style.display !== 'none') {
            const isMatch = imageType === 'variant'
              ? (thumbSlide.dataset.imageId === imageId &&
                thumbSlide.dataset.variantId === variantId &&
                thumbSlide.dataset.imageType === imageType)
              : (thumbSlide.dataset.imageId === imageId &&
                thumbSlide.dataset.imageType === imageType);
            if (isMatch) {
              galleryThumbs.slideTo(i);
              break;
            }
          }
        }
      }
    });

    // Handle thumbnail clicks
    if (galleryThumbs) {
      galleryThumbs.on("click", (swiper, event) => {
        const clickedSlide = event.target.closest(".swiper-slide");
        if (clickedSlide) {
          // Get data attributes from clicked thumbnail
          const imageId = clickedSlide.dataset.imageId;
          const imageType = clickedSlide.dataset.imageType;
          const variantId = clickedSlide.dataset.variantId;

          // Find matching slide using actual Swiper index for slideTo
          const mainSlides = productGalleryMain.slides;

          for (let i = 0; i < mainSlides.length; i++) {
            const mainSlide = mainSlides[i];
            if (mainSlide.style.display !== 'none') {
              const mainImageId = mainSlide.dataset.imageId;
              const mainImageType = mainSlide.dataset.imageType;
              const mainVariantId = mainSlide.dataset.variantId;

              const isMatch = imageType === 'variant'
                ? (mainImageId === imageId &&
                  mainVariantId === variantId &&
                  mainImageType === imageType)
                : (mainImageId === imageId &&
                  mainImageType === imageType);

              if (isMatch) {
                productGalleryMain.slideTo(i);
                break;
              }
            }
          }
        }
      });
    }
  }

  if (document.querySelector(".js-category-carousel-swiper")) {
    // Category Carousel Slider
    new Swiper(".js-category-carousel-swiper", {
      slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 24,
      loop: true,
      navigation: {
        nextEl: ".category-carousel__next",
        prevEl: ".category-carousel__prev",
      },
      scrollbar: {
        el: ".category-carousel .swiper-scrollbar",
        draggable: true,
      },
      breakpoints: {
        992: {
          slidesPerView: 4,
          centeredSlides: false,
          loop: false,
        },
        1280: {
          slidesPerView: 5,
          loop: false,
          centeredSlides: false,
        },
      },
    });
  }
};

export { initSliders };
